import { render, staticRenderFns } from "./PacksVideoModal.vue?vue&type=template&id=0bcf0198&"
import script from "./PacksVideoModal.vue?vue&type=script&lang=js&"
export * from "./PacksVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports